import { useEffect, useState } from 'react';

/**
 * Текущее время, обновляемое раз в `intervalMs`, пока `active`: признак
 * «генерация зависла» должен появиться, даже если новых данных с сервера нет.
 */
export function useNow(active: boolean, intervalMs = 30_000): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (!active) return;
    setNow(Date.now());
    const t = window.setInterval(() => setNow(Date.now()), intervalMs);
    return () => window.clearInterval(t);
  }, [active, intervalMs]);
  return now;
}
